export default __webpack_public_path__ + "static/media/hover1.e9669ce6.png";